/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import { withSessionSsr } from '../../src/utils/withSession';
import { useState, useRef, useEffect, useMemo } from 'react';
import Fade from '@mui/material/Fade';
import { styled } from '@mui/system';
import { tokens } from '../../src/tokens';
import Head from 'next/head';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';

import {
  CircularProgress,
  Box,
  Typography,
  Paper,
  Avatar,
  Chip,
  Button,
} from '@mui/material';
import { keyframes } from '@mui/system';
import styles from '../../styles/Test.module.css';
import ChatFooter from '../../src/components/blockquiry-chat/components/ChatFooter';
import ChatHeader from '../../src/components/blockquiry-chat/components/ChatHeader';
import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined';
import CopyChat from '../../src/components/accountdetails/copypaste/CopyChat';
import LightTooltip from '../../src/utils/LightTooltip';

// Custom link component
const CustomLink = ({ href, children }) => (
  <a
    href={href}
    style={{ textDecoration: 'underline' }}
    target="_blank"
    rel="noopener noreferrer"
  >
    {children}
  </a>
);

// Map 'a' tag to the CustomLink component
const components = {
  a: CustomLink,
};

const TooltipTypo = styled(Typography)(() => ({
  fontFamily: 'Roboto, Arial,  sans-serif',
  fontSize: '0.7500rem',
  fontWeight: 'normal',
  letterSpacing: '.0107142857em',
  // alignItems: 'center',
  color: tokens.palette_primary,
  textAlign: 'left',
}));

const SourceTypo = styled(Typography)(() => ({
  fontFamily: 'Roboto, Arial,  sans-serif',
  fontSize: '0.87500rem',
  lineHeight: '1.00rem',
  fontWeight: 500,
  letterSpacing: '.0107142867em',
  // alignItems: 'center',
  color: tokens.palette_primary,
  textAlign: 'left',
}));

const loadingGradient = keyframes`
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
`;
const fadeInMessage = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const userMessageStyle = {
  background: tokens.palette_primary,
  padding: '0.75rem',
  fontFamily: 'Roboto,arial,sans-serif',
  fontSize: '1.00rem',
  color: tokens.token_surface,
  margin: '0.325rem',
  borderRadius: '0.5rem',
  // justifyContent: 'flex-end',
};

const userMessageWaitingStyle = {
  padding: '0.75rem',
  borderRadius: '0.5rem',
  fontFamily: 'Roboto,arial,sans-serif',
  fontSize: '1.00rem',
  margin: '0.325rem',
  color: tokens.token_surface,
  background: `linear-gradient(to left, #0A2B3B, #082B3B, #0C3F5A, #156D9F, #0C5678, #0D334D)`,
  backgroundSize: '200% 200%',
  backgroundPosition: '-100% 0',
  animation: 'loading-gradient 2s ease-in-out infinite',
  animationDirection: 'alternate',
  animation: `${loadingGradient} 2s ease-in-out infinite alternate`,
};

const apiMessageStyle = {
  background: tokens.token_grey_300,
  padding: '0.75rem',
  fontFamily: 'Roboto,arial,sans-serif',
  fontSize: '1.00rem',
  color: tokens.palette_primary,
  animation: 'fadein 0.5s',
  margin: '0.325rem',
  borderRadius: '0.5rem',
};

const BlockTypo = styled(Typography)(() => ({
  fontFamily: 'play',
  opacity: 1,
  fontSize: '1.75rem',
  fontWeight: 700,
  lineHeight: '1.25rem',
  textAlign: 'center',
  paddingLeft: 0,
  whiteSpace: 'wrap',
  color: tokens.palette_secondary,
}));

export default function Chat({ chatUserId }) {
  console.log('chatUserId in Chat component', chatUserId);

  const [visibleApiMessages, setVisibleApiMessages] = useState([]);
  const [userInput, setUserInput] = useState('');
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([
    {
      message: 'Hello! How can I help?',
      type: 'apiMessage',
    },
  ]);

  const messageListRef = useRef(null);
  const textAreaRef = useRef(null);

  // Auto scroll chat to bottom
  useEffect(() => {
    const messageList = messageListRef.current;
    messageList.scrollTop = messageList.scrollHeight;
  }, [messages]);

  // Focus on text field on load
  useEffect(() => {
    textAreaRef.current.focus();
  }, []);

  // Handle errors
  const handleError = () => {
    setMessages((prevMessages) => [
      ...prevMessages,
      {
        message: 'Oops! There seems to be an error. Please try again.',
        type: 'apiMessage',
      },
    ]);
    setLoading(false);
    setUserInput('');
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (userInput.trim() === '') {
      return;
    }

    setLoading(true);

    setMessages((prevMessages) => [
      ...prevMessages,
      { message: userInput, type: 'userMessage' },
    ]);

    // Send user question and history to API
    const response = await fetch('/api/chat_api/chat_qa_v2', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ question: userInput, history }),
    });

    if (!response.ok) {
      handleError();
      return;
    }

    // Reset user input
    setUserInput('');
    const result = await response.json();
    setMessages((prevMessages) => [
      ...prevMessages,
      { message: result.response.text, type: 'apiMessage', metadata: result.metadata },
    ]);

    setLoading(false)
  };

  // Prevent blank submissions and allow for multiline input
  const handleEnter = (e) => {
    if (e.key === 'Enter' && userInput) {
      if (!e.shiftKey && userInput) {
        handleSubmit(e);
      }
    } else if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  const ChatBubbleBox = (message, index) => {
    return (
      <Box
        component={Paper}
        className="chat-bubble-box"
        key={index}
        sx={
          message.type === 'userMessage' &&
          loading &&
          index === messages.length - 1
            ? userMessageWaitingStyle
            : message.type === 'apiMessage'
            ? apiMessageStyle
            : userMessageStyle
        }
        style={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          marginTop: '0.65rem',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            padding: '0.25rem',
            top: 0,
            right: 0,
            color: tokens.palette_primary,
          }}
        >
          <CopyChat stringToCopy={message.message} />
        </Box>
        {/* Display the correct icon depending on the message type */}
        {message.type === 'apiMessage' ? (
          <Avatar
            variant="rounded"
            sx={{
              bgcolor: tokens.token_surface,
              width: '28px',
              height: '28px',
              // marginRight: '1rem',
              borderRadius: '0.25rem',
            }}
            // priority
          >
            <BlockTypo>b</BlockTypo>
          </Avatar>
        ) : (
          <Avatar
            variant="rounded"
            sx={{
              bgcolor: tokens.token_surface,
              width: '28px',
              height: '28px',
              // marginRight: '1rem',
              borderRadius: '0.25rem',
            }}
            // priority
          >
            <PermIdentityOutlinedIcon sx={{ color: tokens.palette_primary }} />
          </Avatar>
        )}

        <Box
          className="chat-message-box"
          sx={{
            lineHeight: '1.75rem',
            marginLeft: '0.50rem',
            paddingTop: '0.25rem',
            width: '100%',
          }}
        >
          {/* Markdown format */}

          <ReactMarkdown
            remarkPlugins={[remarkGfm, remarkMath, rehypeKatex]}
            components={components}
          >
            {message.message}
          </ReactMarkdown>

          {/* Only render sources if it is the last apiMessage NEED TO FIX THIS LOGIC */}
          {message.type === 'apiMessage' &&
            // index === messages.length - 1 &&
            message.metadata &&
            message.metadata.length > 0 && (
              <Box
                className="lower-border"
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'column' },
                  alignItems: 'left',
                  width: '100%', // divider should spans across the full width
                  flexGrow: 1,
                }}
              >
                <Box
                  sx={{
                    borderBottom: `1px solid ${tokens.token_surface}`,
                    width: '100%',
                    marginBottom: '8px',
                  }}
                />
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: 'center',
                    flexWrap: 'wrap', // wrap chips to the next line if needed
                  }}
                >
                  <SourceTypo>Learn more:</SourceTypo>
                  {message.metadata.map((meta, index) => (
                    <LightTooltip
                      title={<TooltipTypo>{meta.title}</TooltipTypo>}
                    >
                      <Chip
                        size="small"
                        key={meta.id}
                        label={meta.root_id}
                        clickable
                        component="a"
                        href={meta.source}
                        target="_blank" // Open the link in a new tab
                        variant="outlined"
                        sx={{
                          // border: `${tokens.token_surface}`,
                          color: tokens.palette_primary,
                          bgcolor: tokens.token_grey_50,
                          marginLeft: '0.5rem',
                        }} // Add some margin between chips
                      />
                    </LightTooltip>
                  ))}
                </Box>
              </Box>
            )}
        </Box>
      </Box>
    );
  };
  useEffect(() => {
    let historyStartIndex = messages.length - 3;
    if (historyStartIndex < 0) {
      historyStartIndex = 0;
    }
    setHistory(
      messages
        .slice(historyStartIndex, messages.length)
        .map((msg) => msg.message)
    );
  }, [messages]);

  return (
    <>
      <Head>
        <title>
          blockquiry Chat | AI Chat Agent for Crypto and Cybercrime Related
          Questions
        </title>
        <meta
          name="description"
          content="AI-powered chat agent specifically trained to help victims of crypto and 
          cybercrime. Get assistance in understanding crypto regulation, privacy, and more."
        />
        <meta
          name="keywords"
          content="blockquiry, AI, cryptocurrency, 
          chat agent, cybercrime victims, cryptocrime victims, crypto regulation, privacy, blockchain economy"
        />
        <meta name="author" content="blockquiry" />
        <meta
          property="og:title"
          content="AI Chat Agent for Crypto and Cybercrime Related
          Questions"
        />
        <meta
          property="og:description"
          content="AI-powered chat agent specifically trained to help victims of crypto and 
          cybercrime. Get assistance in understanding crypto regulation, privacy, and more."
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="/blockquiry92x21.png" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <ChatHeader />

      <Box
        className="main-chat-box"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
          py: { xs: '0.25rem', md: '1.25rem' },
          backgroundColor: tokens.token_surface,
        }}
      >
        <Box
          component={Paper}
          elevation={0}
          sx={{
            width: { xs: '98vw', md: '75vw' },
            height: { xs: '75vh', md: '70vh' },
            border: `1px solid ${tokens.token_table_bottom_border}`,
            bgcolor: tokens.token_grey_100,
            borderRadius: '0.5rem',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '& ::-webkit-scrollbar': {
              // Hide scrollbar for Chrome, Safari and Opera
              display: 'none',
            },
            '& ::-ms-overflow-style': {
              // Hide scrollbar for IE and Edge
              display: 'none',
            },
            '& scrollbarWidth': {
              // Hide scrollbar for Firefox
              display: 'none',
            },
          }}
        >
          <Box
            sx={{
              width: '100%',
              height: '100%',
              overflowY: 'scroll',
              borderRadius: '0.5rem',
            }}
            ref={messageListRef}
          >
            {messages.map((message, index) => {
              return (
                <>
                  {message.type === 'apiMessage' ? (
                    <Fade in={true} timeout={2000}>
                      {ChatBubbleBox(message, index)}
                    </Fade>
                  ) : (
                    ChatBubbleBox(message, index)
                  )}
                </>
              );
            })}
          </Box>
        </Box>

        <Box
          className="search-input-box"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            paddingTop: { xs: '0.50rem', md: '2.00rem' },
            paddingBottom: { xs: '0.50rem', md: '1.00rem' },
            paddingRight: { xs: '0.25rem', md: '1rem' },
            paddingLeft: { xs: '0.25rem', md: '1rem' },
            flexDirection: 'column',
          }}
        >
          <Box sx={{ position: 'relative', display: 'flex', width: '100%' }}>
            <form onSubmit={handleSubmit}>
              <textarea
                disabled={loading}
                onKeyDown={handleEnter}
                ref={textAreaRef}
                autoFocus={false}
                rows={1}
                maxLength={512}
                type="text"
                id="userInput"
                name="userInput"
                placeholder={
                  loading ? 'Waiting for response...' : 'Type your message...'
                }
                value={userInput}
                onChange={(e) => setUserInput(e.target.value)}
                className={styles.textarea}
                style={{
                  position: 'relative',
                  resize: 'none',
                  fontSize: '1.00rem',
                  fontFamily: 'Roboto',
                  padding: '1.00rem 1.00rem',
                  // width: '97vw',
                  borderRadius: '0.5rem',
                  border: `1px solid ${tokens.token_search_border_grey}`,
                  boxShadow: '0 4px 12px rgb(60 63 66 / 15%)',
                  background: tokens.token_surface,
                  color: tokens.token_text_grey_on_white,
                  outline: 'none',
                  '::placeholder': {
                    color: tokens.token_grey_300,
                  },
                  '&:disabled': {
                    opacity: 0.5,
                  },
                  '&:hover': { boxShadow: '1px 1px 6px rgb(32 33 36 / 28%)' },
                }}
                sx={{ xs: '100vw', md: '75vw' }}
              />
              <button
                type="submit"
                disabled={loading}
                style={{
                  position: 'absolute',
                  top: '0.87rem',
                  right: '1rem',
                  color: 'rgb(165, 162, 162)',
                  background: 'none',
                  padding: '0.3rem',
                  border: 'none',
                  display: 'flex',
                }}
              >
                {loading ? (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '0.2rem',
                      right: '0.25rem',
                    }}
                  >
                    <CircularProgress color="inherit" size={20} />{' '}
                  </Box>
                ) : (
                  // Send icon SVG in input field
                  <svg
                    viewBox="0 0 20 20"
                    style={{
                      transform: 'rotate(90deg)',
                      width: '1.2em',
                      height: '1.2em',
                      fill: tokens.token_apple_grey,
                    }}
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
                  </svg>
                )}
              </button>
            </form>
          </Box>
          <Box sx={{ display: { xs: 'none', sm: 'none' } }}>
            <ChatFooter />
          </Box>
        </Box>
      </Box>
    </>
  );
}



export const getServerSideProps = withSessionSsr(
  async function getServerSideProps({ req }) {
    const user = req.session.userId;
  console.log('chatUserId', user);
    return {
      props: {
        chatUserId: user,
      },
    };
  },
);






